import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../h2Api'

export const RESUME_LOADED = 'RESUME_LOADED'
export const RESUME_DELETED = 'RESUME_DELETED'
export const RESUME_CREATED = 'RESUME_CREATED'
export const RESUME_LISTING_LOADED = 'RESUME_LISTING_LOADED'
export const DOCUMENT_FORMAT_LISTING_LOADED = 'DOCUMENT_FORMAT_LISTING_LOADED'
export const DOCUMENT_FORMAT_SAVE = 'DOCUMENT_FORMAT_SAVE'
export const EDITABLE_RESUME_INITIAL_LOAD = 'EDITABLE_RESUME_INITIAL_LOAD'
export const EDITABLE_RESUME_UPDATE_RESUME = 'EDITABLE_RESUME_UPDATE_RESUME'
export const EDITABLE_REMOVE_ID_TO_SECTION = 'EDITABLE_REMOVE_ID_TO_SECTION'
export const EDITABLE_ADD_ID_TO_SECTION = 'EDITABLE_ADD_ID_TO_SECTION'
export const EDITABLE_SET_AS_SECTION = 'EDITABLE_SET_AS_SECTION'
export const RESUME_SECTION_ITEM_TO_ADD = 'RESUME_SECTION_ITEM_TO_ADD'
export const RESUME_SAVE_PORTFOLIO = 'RESUME_SAVE_PORTFOLIO'
export const RESUME_FORMAT_UPDATED = 'RESUME_FORMAT_UPDATED'
export const EDITABLE_RESUME_REPLACE_RESUME = 'EDITABLE_RESUME_REPLACE_RESUME'

export const AWARD_FORM = 'AWARD_FORM'
export const AWARD_LISTING = 'AWARD_LISTING'
export const CONTACT_FORM = 'CONTACT_FORM'
export const CONTACT_LISTING = 'CONTACT_LISTING'
export const EMPLOYMENT_FORM = 'EMPLOYMENT_FORM'
export const EMPLOYMENT_LISTING = 'EMPLOYMENT_LISTING'
export const CERTIFICATION_FORM = 'CERTIFICATION_FORM'
export const CERTIFICATION_LISTING = 'CERTIFICATION_LISTING'
export const EDUCATION_FORM = 'EDUCATION_FORM'
export const EDUCATION_LISTING = 'EDUCATION_LISTING'
export const MILITARY_FORM = 'MILITARY_FORM'
export const SKILL_FORM = 'SKILL_FORM'
export const SKILL_LISTING = 'SKILL_LISTING'
export const OBJECTIVE_FORM = 'OBJECTIVE_FORM'
export const OBJECTIVE_LISTING = 'OBJECTIVE_LISTING'
export const MILITARY_LISTING = 'MILITARY_LISTING'

export const PROFESSIONAL_REFERENCES_LISTING = 'PROFESSIONAL_REFERENCES_LISTING'
export const PROFESSIONAL_REFERENCES_FORM = 'PROFESSIONAL_REFERENCES_FORM'

export const LETTER_CREATED = 'LETTER_CREATED'
export const LETTER_UPDATED = 'LETTER_UPDATED'
export const LETTER_LISTING_LOADED = 'LETTER_LISTING_LOADED'
export const LETTER_LOADED = 'LETTER_LOADED'
export const LETTER_DELETED = 'LETTER_DELETED'
export const EDITABLE_LETTER_INITIAL_LOAD = 'EDITABLE_LETTER_INITIAL_LOAD'
export const EDITABLE_LETTER_UPDATED = 'EDITABLE_LETTER_UPDATED'
export const EDITABLE_LETTER_REMOVE_ID_TO_SECTION = 'EDITABLE_LETTER_REMOVE_ID_TO_SECTION'
export const EDITABLE_LETTER_ADD_ID_TO_SECTION = 'EDITABLE_LETTER_ADD_ID_TO_SECTION'
export const EDITABLE_LETTER_SET_AS_SECTION = 'EDITABLE_LETTER_SET_AS_SECTION'
export const LETTER_SECTION_ITEM_TO_ADD = 'LETTER_SECTION_ITEM_TO_ADD'
export const LETTER_FORMAT_UPDATED = 'LETTER_FORMAT_UPDATED'
export const LETTER_SAVE_PORTFOLIO = 'LETTER_SAVE_PORTFOLIO'
export const LETTER_FORM = 'LETTER_FORM'

export const CLOSING_LISTING = 'CLOSING_LISTING'
export const CLOSING_FORM = 'CLOSING_FORM'
export const ADDRESSEE_LISTING = 'ADDRESSEE_LISTING'
export const ADDRESSEE_FORM = 'ADDRESSEE_FORM'

export const REFERENCE_LISTING_LOADED = 'REFERENCE_LISTING_LOADED'
export const REFERENCE_LOADED = 'REFERENCE_LOADED'
export const REFERENCE_DELETED = 'REFERENCE_DELETED'
export const EDITABLE_REFERENCES_INITIAL_LOAD = 'EDITABLE_REFERENCES_INITIAL_LOAD'
export const EDITABLE_REFERENCES_REMOVE_ID_TO_SECTION =
  'EDITABLE_REFERENCES_REMOVE_ID_TO_SECTION'
export const EDITABLE_REFERENCES_ADD_ID_TO_SECTION =
  'EDITABLE_REFERENCES_ADD_ID_TO_SECTION'
export const EDITABLE_REFERENCES_SET_AS_SECTION = 'EDITABLE_REFERENCES_SET_AS_SECTION'
export const REFERENCES_SECTION_ITEM_TO_ADD = 'REFERENCES_SECTION_ITEM_TO_ADD'
export const REFERENCES_FORMAT_UPDATED = 'REFERENCES_FORMAT_UPDATED'
export const REFERENCE_SAVE_PORTFOLIO = 'REFERENCE_SAVE_PORTFOLIO'
export const REFERENCE_CREATED = 'REFERENCE_CREATED'
export const REFERENCE_UPDATED = 'REFERENCE_UPDATED'

/** Resume stuff */

export const loadResumePartsForEditing = resumeParts => {
  return { type: EDITABLE_RESUME_INITIAL_LOAD, resumeParts }
}

export const addPartToResumeSection = (itemId, sectionKey) => {
  return { type: EDITABLE_ADD_ID_TO_SECTION, sectionKey, itemId }
}

export const addItemToResumeSections = (item, sectionKey) => {
  return { type: RESUME_SECTION_ITEM_TO_ADD, sectionKey, item }
}

export const setPartAsResumeSection = (itemId, sectionKey) => {
  console.log(EDITABLE_SET_AS_SECTION, itemId, sectionKey)

  return { type: EDITABLE_SET_AS_SECTION, sectionKey, itemId }
}

export const removePartFromResumeSection = (itemId, sectionKey) => {
  console.log(`Removing ${itemId} from section ${sectionKey}`)

  return { type: EDITABLE_REMOVE_ID_TO_SECTION, sectionKey, itemId }
}

export const replaceResume = resume => {
  return { type: EDITABLE_RESUME_REPLACE_RESUME, resume }
}

/**
 * This checks the props for the resumeId and then updates the form with it so
 * that the item being created can be associated with a resume
 * @param props
 * @param formName
 * @returns {function(*): void}
 */
export const checkResumeParam = (props, formName) => dispatch => {
  const resumeId = props.resumeId

  if (resumeId) {
    dispatch(formActions.change(`${formName}.resumeId`, resumeId))
  }
}

export const loadDocumentFormats = () => {
  return h2Api.get('/jobtools/formats')({ type: DOCUMENT_FORMAT_LISTING_LOADED })
}

export const loadResumeListing = () => {
  return h2Api.get('/jobtools/resume')({ type: RESUME_LISTING_LOADED })
}

export const deleteResume = resumeId => {
  return h2Api.doDelete(`/jobtools/resume/${resumeId}`)({ type: RESUME_DELETED })
}

export const loadResume = resumeId => {
  return h2Api.get(`/jobtools/resume/${resumeId}`)({ type: RESUME_LOADED })
}

export const createResume = form => {
  return h2Api.post(`/jobtools/resume`, form)({ type: RESUME_CREATED })
}

export const renameResume = (resumeId, form) => {
  return h2Api.put(
    `/jobtools/resume/${resumeId}/title`,
    form
  )({ type: EDITABLE_RESUME_UPDATE_RESUME })
}

export const updateResume = (resumeId, form) => {
  return h2Api.put(
    `/jobtools/resume/${resumeId}`,
    form
  )({ type: EDITABLE_RESUME_UPDATE_RESUME })
}

export const saveResumeToPortfolio = resumeId => {
  return h2Api.post(`/jobtools/resume/${resumeId}/save`)({ type: RESUME_SAVE_PORTFOLIO })
}

export const loadObjective = itemId => {
  return h2Api.get(`/jobtools/objective/${itemId}`)({ type: OBJECTIVE_FORM })
}

export const loadObjectiveListing = () => {
  return h2Api.get(`/jobtools/objective`)({ type: OBJECTIVE_LISTING })
}

export const loadAward = itemId => {
  return h2Api.get(`/jobtools/award/${itemId}`)({ type: AWARD_FORM })
}

export const loadAwardsListing = itemId => {
  return h2Api.get(`/jobtools/award`)({ type: AWARD_LISTING })
}

export const loadSkill = itemId => {
  return h2Api.get(`/jobtools/skill/${itemId}`)({ type: SKILL_FORM })
}

export const loadSkillListing = () => {
  return h2Api.get(`/jobtools/skill`)({ type: SKILL_LISTING })
}

export const loadCertification = itemId => {
  return h2Api.get(`/jobtools/certification/${itemId}`)({ type: CERTIFICATION_FORM })
}

export const loadCertificationListing = () => {
  return h2Api.get(`/jobtools/certification`)({ type: CERTIFICATION_LISTING })
}

export const loadEducation = itemId => {
  return h2Api.get(`/jobtools/education/${itemId}`)({ type: EDUCATION_FORM })
}

export const loadEducationListing = () => {
  return h2Api.get(`/jobtools/education`)({ type: EDUCATION_LISTING })
}

export const loadEmployment = itemId => {
  return h2Api.get(`/jobtools/employment/${itemId}`)({ type: EMPLOYMENT_FORM })
}

export const loadEmploymentListing = () => {
  return h2Api.get(`/jobtools/employment`)({ type: EMPLOYMENT_LISTING })
}

export const loadMilitary = itemId => {
  return h2Api.get(`/jobtools/military/${itemId}`)({ type: MILITARY_FORM })
}

export const loadMilitaryListing = () => {
  return h2Api.get(`/jobtools/military`)({ type: MILITARY_LISTING })
}

export const loadContact = itemId => {
  return h2Api.get(`/jobtools/contact/${itemId}`)({ type: CONTACT_FORM })
}

export const loadContactListing = () => {
  return h2Api.get(`/jobtools/contact`)({ type: CONTACT_LISTING })
}

export const loadDocumentFormat = formatId => {
  return h2Api.get(`/jobtools/formats/${formatId}`)({ type: DOCUMENT_FORMAT_SAVE })
}

export const createDocumentFormat = form => {
  return h2Api.post(`/jobtools/formats`, form)({ type: DOCUMENT_FORMAT_SAVE })
}

export const createContact = form => {
  return h2Api.post(`/jobtools/contact`, form)({ type: CONTACT_FORM })
}

export const createObjective = form => {
  return h2Api.post(`/jobtools/objective`, form)({ type: OBJECTIVE_FORM })
}

export const createAward = form => {
  return h2Api.post(`/jobtools/award`, form)({ type: AWARD_FORM })
}

export const createSkill = form => {
  return h2Api.post(`/jobtools/skill`, form)({ type: SKILL_FORM })
}

export const createCertification = form => {
  return h2Api.post(`/jobtools/certification`, form)({ type: CERTIFICATION_FORM })
}

export const createEducation = form => {
  return h2Api.post(`/jobtools/education`, form)({ type: EDUCATION_FORM })
}

export const createEmployment = form => {
  return h2Api.post(`/jobtools/employment`, form)({ type: EMPLOYMENT_FORM })
}

export const createMilitary = form => {
  return h2Api.post(`/jobtools/military`, form)({ type: MILITARY_FORM })
}

export const updateDocumentFormat = (form, originalId) => {
  return h2Api.put(
    `/jobtools/formats/${originalId}`,
    form
  )({ type: DOCUMENT_FORMAT_SAVE })
}

export const updateContact = (form, originalId) => {
  return h2Api.put(`/jobtools/contact/${originalId}`, form)({ type: CONTACT_FORM })
}

export const updateObjective = (form, originalId) => {
  return h2Api.put(`/jobtools/objective/${originalId}`, form)({ type: OBJECTIVE_FORM })
}

export const updateAward = (form, originalId) => {
  return h2Api.put(`/jobtools/award/${originalId}`, form)({ type: AWARD_FORM })
}

export const updateSkill = (form, originalId) => {
  return h2Api.put(`/jobtools/skill/${originalId}`, form)({ type: SKILL_FORM })
}

export const updateCertification = (form, originalId) => {
  return h2Api.put(
    `/jobtools/certification/${originalId}`,
    form
  )({ type: CERTIFICATION_FORM })
}

export const updateEducation = (form, originalId) => {
  return h2Api.put(`/jobtools/education/${originalId}`, form)({ type: EDUCATION_FORM })
}

export const updateEmployment = (form, originalId) => {
  return h2Api.put(`/jobtools/employment/${originalId}`, form)({ type: EMPLOYMENT_FORM })
}

export const updateMilitary = (form, originalId) => {
  return h2Api.put(`/jobtools/military/${originalId}`, form)({ type: MILITARY_FORM })
}

export const updateResumeFormat = (form, originalId) => {
  return h2Api.put(
    `/jobtools/resume/${originalId}/format`,
    form
  )({ type: RESUME_FORMAT_UPDATED })
}

export const deleteContact = id => {
  return h2Api.doDelete(`/jobtools/contact/${id}`)({ type: CONTACT_FORM })
}

export const deleteObjective = id => {
  return h2Api.doDelete(`/jobtools/objective/${id}`)({ type: OBJECTIVE_FORM })
}

export const deleteAward = id => {
  return h2Api.doDelete(`/jobtools/award/${id}`)({ type: AWARD_FORM })
}

export const deleteSkill = id => {
  return h2Api.doDelete(`/jobtools/skill/${id}`)({ type: SKILL_FORM })
}

export const deleteCertification = id => {
  return h2Api.doDelete(`/jobtools/certification/${id}`)({ type: CERTIFICATION_FORM })
}

export const deleteEducation = id => {
  return h2Api.doDelete(`/jobtools/education/${id}`)({ type: EDUCATION_FORM })
}

export const deleteEmployment = id => {
  return h2Api.doDelete(`/jobtools/employment/${id}`)({ type: EMPLOYMENT_FORM })
}

export const deleteMilitary = id => {
  return h2Api.doDelete(`/jobtools/military/${id}`)({ type: MILITARY_FORM })
}

export const deleteAwardFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/award/${id}`)({ type: AWARD_FORM })
  ).then(t => dispatch(removePartFromResumeSection(id, 'awards')))
}

export const deleteSkillFromResume = (resumeId, id) => dispatch => {
  console.log('ADSDAD', resumeId)

  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/skill/${id}`)({ type: SKILL_FORM })
  ).then(t => dispatch(removePartFromResumeSection(id, 'skills')))
}

export const deleteCertificationFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/certification/${id}`)({
      type: CERTIFICATION_FORM
    })
  ).then(t => dispatch(removePartFromResumeSection(id, 'certifications')))
}

export const deleteEducationFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/education/${id}`)({
      type: EDUCATION_FORM
    })
  ).then(t => dispatch(removePartFromResumeSection(id, 'education')))
}

export const deleteEmploymentFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/employment/${id}`)({
      type: EMPLOYMENT_FORM
    })
  ).then(t => dispatch(removePartFromResumeSection(id, 'workExperience')))
}

export const deleteMilitaryFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/military/${id}`)({ type: MILITARY_FORM })
  ).then(t => dispatch(removePartFromResumeSection(id, 'military')))
}
export const deleteObjectiveFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/objective/${id}`)({
      type: OBJECTIVE_FORM
    })
  ).then(t => dispatch(setPartAsResumeSection(null, 'objectiveId')))
}
export const deleteContactFromResume = (resumeId, id) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/resume/${resumeId}/contact/${id}`)({ type: CONTACT_FORM })
  ).then(t => dispatch(setPartAsResumeSection(null, 'contactId')))
}

export const addAwardToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/award/${id}`)({ type: AWARD_FORM })
}

export const addSkillToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/skill/${id}`)({ type: SKILL_FORM })
}

export const addCertificationToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/certification/${id}`)({
    type: CERTIFICATION_FORM
  })
}

export const addEducationToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/education/${id}`)({
    type: EDUCATION_FORM
  })
}

export const addEmploymentToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/employment/${id}`)({
    type: EMPLOYMENT_FORM
  })
}

export const addMilitaryToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/military/${id}`)({
    type: MILITARY_FORM
  })
}
export const addObjectiveToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/objective/${id}`)({
    type: OBJECTIVE_FORM
  })
}
export const addContactToResume = (resumeId, id) => {
  return h2Api.post(`/jobtools/resume/${resumeId}/contact/${id}`)({ type: CONTACT_FORM })
}

/**
 *Cover letter stuff
 */

export const checkLetterParam = (props, formName) => dispatch => {
  const letterId = props.letterId

  if (letterId) {
    dispatch(formActions.change(`${formName}.letterId`, letterId))
  }
}

export const loadLetterPartsForEditing = parts => {
  return { type: EDITABLE_LETTER_INITIAL_LOAD, parts }
}

export const loadLetterAfterUpdate = letter => {
  return { type: EDITABLE_LETTER_UPDATED, letter }
}

export const createLetter = form => {
  return h2Api.post(`/jobtools/letter`, form)({ type: LETTER_CREATED })
}

export const renameLetter = (letterId, form) => {
  return h2Api.put(`/jobtools/letter/${letterId}/title`, form)({ type: LETTER_UPDATED })
}

export const updateLetterFormat = (form, originalId) => {
  return h2Api.put(
    `/jobtools/letter/${originalId}/format`,
    form
  )({ type: LETTER_FORMAT_UPDATED })
}

export const updateLetter = (form, originalId) => {
  return h2Api.put(`/jobtools/letter/${originalId}`, form)({ type: LETTER_FORM })
}

export const addPartToLetterSection = (itemId, sectionKey) => {
  return { type: EDITABLE_LETTER_ADD_ID_TO_SECTION, sectionKey, itemId }
}

export const addItemToLetterSections = (item, sectionKey) => {
  return { type: LETTER_SECTION_ITEM_TO_ADD, sectionKey, item }
}

export const setPartAsLetterSection = (itemId, sectionKey) => {
  return { type: EDITABLE_LETTER_SET_AS_SECTION, sectionKey, itemId }
}

export const removePartFromLetterSection = (itemId, sectionKey) => {
  console.log(`Removing ${itemId} from section ${sectionKey}`)

  return { type: EDITABLE_LETTER_REMOVE_ID_TO_SECTION, sectionKey, itemId }
}

export const loadLetterListing = () => {
  return h2Api.get('/jobtools/letter')({ type: LETTER_LISTING_LOADED })
}

export const deleteLetter = id => {
  return h2Api.doDelete(`/jobtools/letter/${id}`)({ type: LETTER_DELETED })
}

export const loadAddressees = () => {
  return h2Api.get(`/jobtools/addressee`)({ type: ADDRESSEE_LISTING })
}

export const loadAddressee = originalId => {
  return h2Api.get(`/jobtools/addressee/${originalId}`)({ type: ADDRESSEE_FORM })
}

export const deleteAddressee = originalId => {
  return h2Api.doDelete(`/jobtools/addressee/${originalId}`)({ type: ADDRESSEE_FORM })
}

export const saveAddressee = (form, originalId) => {
  return h2Api.put(`/jobtools/addressee/${originalId}`, form)({ type: ADDRESSEE_FORM })
}

export const createAddressee = form => {
  return h2Api.post(`/jobtools/addressee`, form)({ type: ADDRESSEE_FORM })
}

export const addAddresseeToLetter = (letterId, id) => {
  return h2Api.post(`/jobtools/letter/${letterId}/addressee/${id}`)({
    type: ADDRESSEE_FORM
  })
}

export const loadClosings = () => {
  return h2Api.get(`/jobtools/closing`)({ type: CLOSING_LISTING })
}

export const loadClosing = originalId => {
  return h2Api.get(`/jobtools/closing/${originalId}`)({ type: CLOSING_FORM })
}

export const deleteClosing = originalId => {
  return h2Api.doDelete(`/jobtools/closing/${originalId}`)({ type: CLOSING_FORM })
}

export const saveClosing = (form, originalId) => {
  return h2Api.put(`/jobtools/closing/${originalId}`, form)({ type: CLOSING_FORM })
}

export const createClosing = form => {
  return h2Api.post(`/jobtools/closing`, form)({ type: CLOSING_FORM })
}

export const addClosingToLetter = (letterId, id) => {
  return h2Api.post(`/jobtools/letter/${letterId}/closing/${id}`)({ type: CLOSING_FORM })
}

export const loadLetter = letterId => {
  return h2Api.get(`/jobtools/letter/${letterId}`)({ type: LETTER_LOADED })
}

export const saveLetterToPortfolio = letterId => {
  return h2Api.post(`/jobtools/letter/${letterId}/save`)({ type: LETTER_SAVE_PORTFOLIO })
}

export const addContactToLetter = (letterId, id) => {
  return h2Api.post(`/jobtools/letter/${letterId}/contact/${id}`)({ type: CONTACT_FORM })
}

/**
 *Reference list stuff
 */

/**
 * This checks the props for the resumeId and then updates the form with it so
 * that the item being created can be associated with a resume
 * @param props
 * @param formName
 * @returns {function(*): void}
 */
export const checkReferenceListParam = (props, formName) => dispatch => {
  const resumeId = props.referenceListId

  if (resumeId) {
    dispatch(formActions.change(`${formName}.referenceListId`, resumeId))
  }
}

export const loadReferencePartsForEditing = parts => {
  return { type: EDITABLE_REFERENCES_INITIAL_LOAD, parts }
}

export const updateReferenceListFormat = (form, originalId) => {
  return h2Api.put(
    `/jobtools/reference/${originalId}/format`,
    form
  )({ type: REFERENCES_FORMAT_UPDATED })
}

export const loadReferenceListing = () => {
  return h2Api.get('/jobtools/reference')({ type: REFERENCE_LISTING_LOADED })
}

export const deleteReference = id => {
  return h2Api.doDelete(`/jobtools/reference/${id}`)({ type: REFERENCE_DELETED })
}

export const createReferenceList = form => {
  return h2Api.post(`/jobtools/reference`, form)({ type: REFERENCE_CREATED })
}

export const renameReferenceList = (listId, form) => {
  return h2Api.put(
    `/jobtools/reference/${listId}/title`,
    form
  )({ type: REFERENCE_UPDATED })
}

export const addProfessionalReferenceToReferenceList = (referenceId, id) => {
  return h2Api.post(`/jobtools/reference/${referenceId}/professionalreference/${id}`)({
    type: PROFESSIONAL_REFERENCES_FORM
  })
}

export const removeProfessionalReferenceToReferenceList = (
  referenceId,
  id
) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/jobtools/reference/${referenceId}/professionalreference/${id}`)({
      type: PROFESSIONAL_REFERENCES_FORM
    })
  ).then(t => dispatch(removePartFromReferenceSection(id, 'references')))
}

export const loadReference = referenceId => {
  return h2Api.get(`/jobtools/reference/${referenceId}`)({ type: REFERENCE_LOADED })
}

export const loadProfessionalReferences = () => {
  return h2Api.get(`/jobtools/professionalreference`)({
    type: PROFESSIONAL_REFERENCES_LISTING
  })
}

export const loadProfessionalReference = originalId => {
  return h2Api.get(`/jobtools/professionalreference/${originalId}`)({
    type: PROFESSIONAL_REFERENCES_FORM
  })
}

export const saveProfessionalReference = (form, originalId) => {
  return h2Api.put(
    `/jobtools/professionalreference/${originalId}`,
    form
  )({ type: PROFESSIONAL_REFERENCES_FORM })
}

export const createProfessionalReference = form => {
  return h2Api.post(
    `/jobtools/professionalreference`,
    form
  )({ type: PROFESSIONAL_REFERENCES_FORM })
}

export const deleteProfessionalReference = originalId => {
  return h2Api.doDelete(`/jobtools/professionalreference/${originalId}`)({
    type: PROFESSIONAL_REFERENCES_FORM
  })
}

export const saveReferenceToPortfolio = referenceId => {
  return h2Api.post(`/jobtools/reference/${referenceId}/save`)({
    type: REFERENCE_SAVE_PORTFOLIO
  })
}

export const addPartToReferenceSection = (itemId, sectionKey) => {
  return { type: EDITABLE_REFERENCES_ADD_ID_TO_SECTION, sectionKey, itemId }
}

export const addItemToReferenceSections = (item, sectionKey) => {
  return { type: REFERENCES_SECTION_ITEM_TO_ADD, sectionKey, item }
}

export const setPartAsReferenceSection = (itemId, sectionKey) => {
  return { type: EDITABLE_REFERENCES_SET_AS_SECTION, sectionKey, itemId }
}

export const removePartFromReferenceSection = (itemId, sectionKey) => {
  console.log(`Removing ${itemId} from section ${sectionKey}`)

  return { type: EDITABLE_REFERENCES_REMOVE_ID_TO_SECTION, sectionKey, itemId }
}
